export default __webpack_public_path__ + "static/media/empty-state-chart-summary.c713c860.svg";